export default "__VITE_ASSET__5940e2e5__"